import type {
  InsideLayoutPortableText,
  PortableTextButtonRow,
  PortableTextContentGrid,
  SectionBuilderContentGrid,
  PortableTextCTABanner,
  PortableTextFAQAccordion,
  PortableTextFlipCards,
  PortableTextImage,
  SectionBuilderImage,
  PortableTextWistiaVideo,
  SectionBuilderWistiaVideo,
  SectionBuilderCTABanner,
  SectionBuilderFAQAccordion,
  PortableTextMediaTwoColumn,
  SectionBuilderMediaTwoColumn,
  SectionBuilderPortableText,
  SectionBuilderButtonRow,
  SectionBuilderFlipCards,
  CarouselCard,
  SectionBuilderLogoBand,
  SectionBuilderTestimonial,
  PortableTextTestimonial,
  SectionBuilderCalloutWithIcon,
  SectionBuilderWhatsNew,
  PortableTextCardTwoColumns,
  SectionBuilderCardTwoColumns,
  PortableTextContentCard,
  SectionBuilderContentCard,
  SectionBuilderSpeakerBio,
  PortableTextSpeakerBio,
  PortableTextCarouselCard,
  SectionBuilderCarouselCard,
  CodeEmbed,
  SectionBuilderComparisonPlanTable,
  HomepageHeader,
  SectionBuilderResourceCard,
  PortableTextForm,
  UssIntent,
  CodeEmbedPortableText,
  UssPlanSelection,
  UssPersona,
  UssPersonaEduIntent,
  UssPersonaEduConverge,
  UssMessage,
  UssProPlan,
  PersonalizationVariable,
  UssSuccessRedirect,
  UssEmailCheckError,
  SectionBuilderForm,
  SectionBuilderParallaxDeck,
  InlineImageAtom,
  InlineWistiaVideo,
  SectionBuilderAnchorMenu,
  SectionBuilderReviewCards,
  SectionBuilderJumboImageTwoColumn,
  SectionBuilderSpinningTwoColumn,
  LatestNews,
  SectionBuilderCustomTable,
  PortableTextCustomTable,
  CurrencyDropDown,
  MarketingBanner,
} from '~/sanity/types';

import {
  LazyPortableTextFlipCards,
  LazySectionBuilderCTABanner,
  LazyPortableTextCTABanner,
  LazyPortableTextWistiaVideo,
  LazySectionBuilderWistiaVideo,
  LazyPortableTextImageAtom,
  LazySectionBuilderImageAtom,
  LazyInsideLayout,
  LazySectionBuilderMediaTwoColumn,
  LazyPortableTextMediaTwoColumn,
  LazySectionBuilderButtonRow,
  LazyPortableTextButtonRow,
  LazyPortableTextContentGrid,
  LazySectionBuilderContentGrid,
  LazyPortableTextFAQAccordion,
  LazySectionBuilderFAQAccordion,
  LazySectionBuilderFlipCards,
  LazyCarouselCard,
  LazySectionBuilderLogoBand,
  LazySectionBuilderTestimonial,
  LazyPortableTextTestimonial,
  LazySectionBuilderPortableText,
  LazySectionBuilderCalloutWithIcon,
  LazySectionBuilderWhatsNew,
  LazyPortableTextCardTwoColumns,
  LazySectionBuilderCardTwoColumns,
  LazySectionBuilderContentCard,
  LazyPortableTextContentCard,
  LazySectionBuilderSpeakerBio,
  LazyPortableTextSpeakerBio,
  LazySectionBuilderCarouselCard,
  LazyPortableTextCarouselCard,
  LazyCodeEmbed,
  LazyInlineCodeEmbed,
  LazySectionBuilderComparisonPlanTable,
  LazyHomepageHeader,
  LazySectionBuilderResourceCard,
  LazyPortableTextForm,
  LazyUssIntent,
  LazyCodeEmbedPortableText,
  LazyUssPlanSection,
  LazyUssPersona,
  LazyUssPersonaEduIntent,
  LazyUssMessage,
  LazyUssProPlan,
  LazyPersonalizationVariable,
  LazyUssSuccessRedirect,
  LazyUssEmailCheckError,
  LazySectionBuilderForm,
  LazySectionBuilderParallaxDeck,
  LazyInlineImageAtom,
  LazyInlineWistiaVideo,
  LazySectionBuilderAnchorMenu,
  LazySectionBuilderReviewCards,
  LazySectionBuilderJumboImageTwoColumn,
  LazySectionBuilderSpinningTwoColumn,
  LazyLatestNews,
  LazySectionBuilderCustomTable,
  LazyUssPersonaEduConverge,
  LazyPortableTextCustomTable,
  LazyCurrencyDropdown,
  LazyMarketingBanner,
} from '#components';

const _mappedComponentKeys = [
  'portableTextButtonRow',
  'portableTextCTABanner',
  'CTABanner',
  'portableTextWistiaVideo',
  'sectionBuilderWistiaVideo',
  'portableTextImage',
  'sectionBuilderImage',
  'portableTextFAQAccordion',
  'portableTextMediaTwoColumn',
  'sectionBuilderMediaTwoColumn',
  'insideLayoutPortableText',
  'portableTextFlipCards',
  'sectionBuilderFlipCards',
  'portableTextContentGrid',
  'sectionBuilderContentGrid',
  'callToAction',
  'sectionBuilderPortableText',
  'sectionBuilderCTABanner',
  'sectionBuilderFAQAccordion',
  'sectionBuilderButtonRow',
  'carouselCard',
  'whyOnshapeSectionBuilder',
  'sectionBuilderTestimonial',
  'sectionBuilderLogoBand',
  'portableTextTestimonial',
  'sectionBuilderCarouselCard',
  'portableTextCarouselCard',
  'codeEmbed',
  'inlineCodeEmbed',
  'inlineImageAtom',
  'inlineWistiaVideo',
  'productSectionBuilder',
  'sectionBuilderCalloutWithIcon',
  'sectionBuilderWhatsNew',
  'sectionBuilderCardTwoColumns',
  'portableTextCardTwoColumns',
  'sectionBuilderContentCard',
  'portableTextContentCard',
  'sectionBuilderSpeakerBio',
  'portableTextSpeakerBio',
  'sectionBuilderComparisonPlanTable',
  'homepageHeader',
  'portableTextForm',
  'sectionBuilderParallaxDeck',
  'sectionBuilderResourceCard',
  'ussIntent',
  'ussPlanSelection',
  'ussProPlan',
  'ussSignupMessage',
  'codeEmbedPortableText',
  'sectionBuilderForm',
  'sectionBuilderAnchorMenu',
  'ussPersona',
  'ussPersonaEduIntent',
  'ussSuccessRedirect',
  'ussLoading',
  'ussPersonaEduConverge',
  'ussMessage',
  'personalizationVariable',
  'ussEmailCheckError',
  'sectionBuilderReviewCards',
  'sectionBuilderCustomTable',
  'portableTextCustomTable',
  'sectionBuilderSpinningTwoColumn',
  'sectionBuilderJumboImageTwoColumn',
  'latestNews',
  'currencyDropDown',
  'marketingBanner',
] as const;

type MappedComponent = (typeof _mappedComponentKeys)[number];

export const componentMap = {
  portableTextButtonRow: ({ value }: { value: PortableTextButtonRow }) => {
    return h(LazyPortableTextButtonRow, { ...value });
  },
  sectionBuilderButtonRow: ({ value }: { value: SectionBuilderButtonRow }) => {
    return h(LazySectionBuilderButtonRow, { ...value });
  },
  portableTextCTABanner: ({ value }: { value: PortableTextCTABanner }) => {
    return h(LazyPortableTextCTABanner, { ...value });
  },
  sectionBuilderCTABanner: ({ value }: { value: SectionBuilderCTABanner }) => {
    return h(LazySectionBuilderCTABanner, { ...value });
  },
  portableTextWistiaVideo: ({ value }: { value: PortableTextWistiaVideo }) => {
    return h(LazyPortableTextWistiaVideo, { ...value });
  },
  inlineWistiaVideo: ({ value }: { value: InlineWistiaVideo }) => {
    return h(LazyInlineWistiaVideo, { ...value });
  },
  sectionBuilderWistiaVideo: ({ value }: { value: SectionBuilderWistiaVideo }) => {
    return h(LazySectionBuilderWistiaVideo, { ...value });
  },
  portableTextImage: ({ value }: { value: PortableTextImage }) => {
    return h(LazyPortableTextImageAtom, { ...value });
  },
  inlineImageAtom: ({ value }: { value: InlineImageAtom }) => {
    return h(LazyInlineImageAtom, { ...value });
  },
  sectionBuilderImage: ({ value }: { value: SectionBuilderImage }) => {
    return h(LazySectionBuilderImageAtom, { ...value });
  },
  insideLayoutPortableText: ({ value }: { value: InsideLayoutPortableText }) => {
    return h(LazyInsideLayout, { ...value });
  },
  portableTextMediaTwoColumn: ({ value }: { value: PortableTextMediaTwoColumn }) => {
    return h(LazyPortableTextMediaTwoColumn, { ...value });
  },
  sectionBuilderMediaTwoColumn: ({ value }: { value: SectionBuilderMediaTwoColumn }) => {
    return h(LazySectionBuilderMediaTwoColumn, { ...value });
  },
  portableTextContentGrid: ({ value }: { value: PortableTextContentGrid }) => {
    return h(LazyPortableTextContentGrid, { ...value });
  },
  sectionBuilderContentGrid: ({ value }: { value: SectionBuilderContentGrid }) => {
    return h(LazySectionBuilderContentGrid, { ...value });
  },
  portableTextFAQAccordion: ({ value }: { value: PortableTextFAQAccordion }) => {
    return h(LazyPortableTextFAQAccordion, { ...value });
  },
  sectionBuilderFAQAccordion: ({ value }: { value: SectionBuilderFAQAccordion }) => {
    return h(LazySectionBuilderFAQAccordion, { ...value });
  },
  portableTextFlipCards: ({ value }: { value: PortableTextFlipCards }) => {
    return h(LazyPortableTextFlipCards, { ...value });
  },
  sectionBuilderFlipCards: ({ value }: { value: SectionBuilderFlipCards }) => {
    return h(LazySectionBuilderFlipCards, { ...value });
  },
  sectionBuilderTestimonial: ({ value }: { value: SectionBuilderTestimonial }) => {
    return h(LazySectionBuilderTestimonial, { ...value });
  },
  portableTextTestimonial: ({ value }: { value: PortableTextTestimonial }) => {
    return h(LazyPortableTextTestimonial, { ...value });
  },
  sectionBuilderPortableText: ({ value }: { value: SectionBuilderPortableText }) => {
    return h(LazySectionBuilderPortableText, { ...value });
  },
  carouselCard: ({ value }: { value: CarouselCard }) => {
    return h(LazyCarouselCard, { ...value });
  },
  sectionBuilderLogoBand: ({ value }: { value: SectionBuilderLogoBand }) => {
    return h(LazySectionBuilderLogoBand, { ...value });
  },
  sectionBuilderJumboImageTwoColumn: ({ value }: { value: SectionBuilderJumboImageTwoColumn }) => {
    return h(LazySectionBuilderJumboImageTwoColumn, { ...value });
  },
  sectionBuilderSpinningTwoColumn: ({ value }: { value: SectionBuilderSpinningTwoColumn }) => {
    return h(LazySectionBuilderSpinningTwoColumn, { ...value });
  },
  sectionBuilderCalloutWithIcon: ({ value }: { value: SectionBuilderCalloutWithIcon }) => {
    return h(LazySectionBuilderCalloutWithIcon, { ...value });
  },
  portableTextCardTwoColumns: ({ value }: { value: PortableTextCardTwoColumns }) => {
    return h(LazyPortableTextCardTwoColumns, { ...value });
  },
  sectionBuilderCardTwoColumns: ({ value }: { value: SectionBuilderCardTwoColumns }) => {
    return h(LazySectionBuilderCardTwoColumns, { ...value });
  },
  portableTextContentCard: ({ value }: { value: PortableTextContentCard }) => {
    return h(LazyPortableTextContentCard, { ...value });
  },
  sectionBuilderContentCard: ({ value }: { value: SectionBuilderContentCard }) => {
    return h(LazySectionBuilderContentCard, { ...value });
  },
  portableTextSpeakerBio: ({ value }: { value: PortableTextSpeakerBio }) => {
    return h(LazyPortableTextSpeakerBio, { ...value });
  },
  sectionBuilderSpeakerBio: ({ value }: { value: SectionBuilderSpeakerBio }) => {
    return h(LazySectionBuilderSpeakerBio, { ...value });
  },
  sectionBuilderCarouselCard: ({ value }: { value: SectionBuilderCarouselCard }) => {
    return h(LazySectionBuilderCarouselCard, { ...value });
  },
  portableTextCarouselCard: ({ value }: { value: PortableTextCarouselCard }) => {
    return h(LazyPortableTextCarouselCard, { ...value });
  },
  callToAction: ({
    value,
    isInline,
  }: {
    value: { url: string; text: string };
    isInline: boolean;
  }) => {
    if (isInline) {
      return h('a', { href: value.url }, value.text);
    } else {
      return h('div', { class: 'callToAction' }, value.text);
    }
  },
  sectionBuilderWhatsNew: ({ value }: { value: SectionBuilderWhatsNew }) => {
    return h(LazySectionBuilderWhatsNew, { ...value });
  },
  codeEmbed: ({ value }: { value: CodeEmbed }) => {
    return h(LazyCodeEmbed, { ...value });
  },
  inlineCodeEmbed: ({ value }: { value: CodeEmbed }) => {
    return h(LazyInlineCodeEmbed, { ...value });
  },
  sectionBuilderComparisonPlanTable: ({ value }: { value: SectionBuilderComparisonPlanTable }) => {
    return h(LazySectionBuilderComparisonPlanTable, { ...value });
  },
  homepageHeader: ({ value }: { value: HomepageHeader }) => {
    return h(LazyHomepageHeader, { ...value });
  },
  ussIntent: ({ value }: { value: UssIntent }) => {
    return h(LazyUssIntent, { ...value });
  },
  ussPlanSelection: ({ value }: { value: UssPlanSelection }) => {
    return h(LazyUssPlanSection, { ...value });
  },
  codeEmbedPortableText: ({ value }: { value: CodeEmbedPortableText }) => {
    return h(LazyCodeEmbedPortableText, { ...value });
  },
  ussPersona: ({ value }: { value: UssPersona }) => {
    return h(LazyUssPersona, { ...value });
  },
  ussPersonaEduIntent: ({ value }: { value: UssPersonaEduIntent }) => {
    return h(LazyUssPersonaEduIntent, { ...value });
  },
  ussPersonaEduConverge: ({ value }: { value: UssPersonaEduConverge }) => {
    return h(LazyUssPersonaEduConverge, { ...value });
  },
  ussMessage: ({ value }: { value: UssMessage }) => {
    return h(LazyUssMessage, { ...value });
  },
  ussProPlan: ({ value }: { value: UssProPlan }) => {
    return h(LazyUssProPlan, { ...value });
  },
  portableTextForm: ({ value }: { value: PortableTextForm }) => {
    return h(LazyPortableTextForm, { ...value });
  },
  personalizationVariable: ({ value }: { value: PersonalizationVariable }) => {
    return h(LazyPersonalizationVariable, { ...value });
  },
  ussSuccessRedirect: ({ value }: { value: UssSuccessRedirect }) => {
    return h(LazyUssSuccessRedirect, { ...value });
  },
  ussEmailCheckError: ({ value }: { value: UssEmailCheckError }) => {
    return h(LazyUssEmailCheckError, { ...value });
  },
  sectionBuilderForm: ({ value }: { value: SectionBuilderForm }) => {
    return h(LazySectionBuilderForm, { ...value });
  },
  sectionBuilderResourceCard: ({ value }: { value: SectionBuilderResourceCard }) => {
    return h(LazySectionBuilderResourceCard, { ...value });
  },
  sectionBuilderParallaxDeck: ({ value }: { value: SectionBuilderParallaxDeck }) => {
    return h(LazySectionBuilderParallaxDeck, { ...value });
  },
  sectionBuilderAnchorMenu: ({ value }: { value: SectionBuilderAnchorMenu }) => {
    return h(LazySectionBuilderAnchorMenu, { ...value });
  },
  sectionBuilderReviewCards: ({ value }: { value: SectionBuilderReviewCards }) => {
    return h(LazySectionBuilderReviewCards, { ...value });
  },
  latestNews: ({ value }: { value: LatestNews }) => {
    return h(LazyLatestNews, { ...value });
  },
  currencyDropDown: ({ value }: { value: CurrencyDropDown }) => {
    return h(LazyCurrencyDropdown, { ...value });
  },
  sectionBuilderCustomTable: ({ value }: { value: SectionBuilderCustomTable }) => {
    return h(LazySectionBuilderCustomTable, { ...value });
  },
  portableTextCustomTable: ({ value }: { value: PortableTextCustomTable }) => {
    return h(LazyPortableTextCustomTable, { ...value });
  },
  marketingBanner: ({ value }: { value: MarketingBanner }) => {
    return h(LazyMarketingBanner, { ...value });
  },
} as Record<MappedComponent, () => VNode>;

export const getComponent = (key: MappedComponent) => {
  if (!_mappedComponentKeys.includes(key)) {
    console.warn(`Component ${key} not found in component map`);
  }
  return componentMap[key];
};
